import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const PembayaranService = {}

PembayaranService.cek = function (token,id_pendaftar) {
    return fetch({
        url: '/transaksi/pembayaran/cek',
        method: 'get',
        params: {
            "id_pendaftar":id_pendaftar
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

PembayaranService.bayar = function (token,data) {
    return fetch({
        url: '/transaksi/pembayaran/store',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

PembayaranService.aktivasiDefer = function (token, data) {
    return fetch({
        url: '/transaksi/pendaftar/aktivasidefer',
        method: 'post',
        data: data,
        headers: {
            "x-api-key": X_API_KEY
        }
    })
}

PembayaranService.cekDefer = function (token, id_pendaftar) {
    return fetch({
        url: '/transaksi/pembayaran_defer/cek',
        method: 'post',
        data: {
            "id_pendaftar": id_pendaftar
        },
        headers: {
            "x-api-key": X_API_KEY
        }
    })
}

PembayaranService.bayarDefer = function (token, data) {
    return fetch({
        url: '/transaksi/pembayaran_defer/store',
        method: 'post',
        data: data,
        headers: {
            "x-api-key": X_API_KEY
        }
    })
}

export default PembayaranService;
